export enum ContainerSizes {
	XS,
	S,
	M,
	L,
	XL,
}
